import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';

class BannerListService {
  submit = new FetchService();
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      banners: [],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
      },
      sort: { field: 'position', order: 'ascend' },
      sortedInfo: {},
    });
    this.form.setInitialValues({
      name: '',
      link: '',
    });
  }

  init = action(() => {
    this.form.reset();
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/banners',
        apiVersion: 'v2',
        query: {
          ...(this.form.getValue('name') && {
            name: this.form.getValue('name'),
          }),
          ...(this.form.getValue('link') && {
            link: this.form.getValue('link'),
          }),
          page: this.pagination.current,
          size: this.pagination.pageSize,
          sort: this.sort,
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.banners = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };
        } else {
          this.banners = [];
          this.pagination = { ...this.pagination, total: 0 };
        }
      });
  });

  handleChange = action((pagination, filters, sort) => {
    this.pagination = { ...this.pagination, ...pagination };
    this.sort = sort;
    this.load();
  });

  handleDelete = (banner) => {
    ConfirmationDialogService.show(
      'Delete Banner',
      `Do you want to delete the banner ${banner.name}?`,
      () => {
        this.submit.fetch({
          method: 'delete',
          url: `/banners/${banner.id}`,
          apiVersion: 'v2',
        }).then(() => {
          if (this.submit.data) {
            this.load();
          }
        })
      },
    )
  }
}

const bannerListService = new BannerListService();

export default bannerListService;
